<template>
  <div class="page">
    <div class="content">
      <div class="margin-bottom userData">
        <div style="display: flex; align-items: center">
          <img :src="examineCheck.avatarUrl" class="avater" style=""/>
        </div>
        <div style="margin-left: 5px">
          <div style="white-space: nowrap">{{examineCheck.name}}</div>
          <div>性别：{{examineCheck.sex === 1 ? '男' : '女'}}</div>
        </div>
      </div>

      <div style="border-top: 1px solid #999; padding: 10px 0">

        <div class="margin-bottom">审核内容</div>
        <div class="row">
          <span class="label">申请技能</span>
          <span class="value">{{ examineCheck.categoryName }}</span>
        </div>
        <div v-if="examineCheck.grade && examineCheck.grade != 0 && ($store.state.shop.id == 154 || $store.state.shop.id == 1)" class="row">
          <span class="label">技能等级</span>
          <span class="value">{{ $store.state.ClerkGradeMap[examineCheck.grade] }}</span>
        </div>
        <template v-if="examineCheckContent.length!=0">
          <div  v-for="(item, index) in examineCheckContent" :key="index">
            <div class="cellBox row" v-if="item.type == 'text'">
              <span class="label">{{item.title}}</span>
              <span class="value">{{item.textValue}}</span>
            </div>
            <div class="row" v-if="item.type == 'video'">
              <span class="label">{{item.title}}</span>
              <span class="value">
                  <video width="100%" height="200px" :src="item.localVideo" controls="controls" @play="handlePlay(item.videoIndex)"></video>
                </span>
            </div>
            <div class="row" v-if="item.type == 'picture'">
              <span class="label">{{item.title}}</span>
              <span class="value">
                <VanImage v-for="(img,index) in item.photoUrls"
                          :key="index"
                          style="margin-right:2%"
                          width="40"
                          height="40"
                          fit="contain"
                          :src="img"
                          @click="HandleclickImg(item.photoUrls,index, true)" />
              </span>
            </div>
            <div class="row" v-if="item.type == 'audio'">
              <span class="label">{{item.title}}</span>
              <span class="value">
                <div class="audio-player" :class="player.id != null && player.id == item.audioIndex ? 'playing' : ''"
                     @click.prevent.stop="playAudio(item.audioIndex, item.audio)">
                <div class="audio">
                  <div class="play-tubiao align-center"><van-icon :name="player.id != null && player.id == item.audioIndex ? 'pause' : 'play'" class="play-a"/></div>
                  <img class="wave" src="/static/images/19/play.png" width="10">
                </div>
              </div>
              </span>
            </div>
          </div>
        </template>
        <div v-if="examineCheck.status === 0" class="cellBox row">
          <van-radio-group v-model="checkStatus" direction="horizontal">
            <van-radio name="1">通过</van-radio>
            <van-radio name="2">不通过</van-radio>
          </van-radio-group>
        </div>
        <div v-if="examineCheck.status === 0 && checkStatus == 2" class="cellBox row">
          <span class="label">不通过原因</span>
          <span class="value">
                <van-field
                    v-model="reason" rows="2" autosize
                    type="textarea"
                    placeholder="请输入不通过原因"
                    style="margin: 10px 0;"
                    maxlength="200"
                    :border="false"/>
              </span>
        </div>
        <div v-else-if="examineCheck.status == 2" class="cellBox row">
          <span class="label">未通过原因</span>
          <span class="value">{{examineCheck.remark}}</span>
        </div>
        <div v-if="examineCheck.status === 0" style="border-top: 1px solid #999; padding: 10px 0"></div>
        <div v-if="examineCheck.status === 0" class="flex justify-center">
          <van-button round type="primary" style="width: 60%" @click="handleConfirm">提交</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Icon, Toast, Dialog, Image as VanImage, ImagePreview, RadioGroup, Radio, Button} from 'vant';
import {getClerkCategoryCheckDetail, checkClerkCategoryExamineApply} from '@/api/clerk_category_examine_check'


Vue.use(VanImage)
    .use(Icon)
    .use(Toast)
    .use(Dialog)
    .use(ImagePreview)
    .use(RadioGroup)
    .use(Radio)
    .use(Button)

export default {
  name: 'clerk-category-apply-detail',
  components: {},
  data() {
    return {
      checkStatus: '1',
      id:null,
      clerkId:null,
      examineCheck: null,
      examineCheckContent: [],
      reason:null,
      videoElement: [],
      player: {
        id: null,
        audio: null
      }
    }
  },
  computed: {

  },
  methods: {
    handlePlay (index) {
      if (this.player.audio != null) {
        this.player.audio.pause()
        this.player = {
          id: null,
          audio: null
        }
      }
      const videoElement = this.videoElement
      if (videoElement && videoElement.length > 0) {
        for (let i = 0; i < videoElement.length; i++) {
          if ( i === index) {
            this.videoElement[i].play()
          } else {
            this.videoElement[i].pause()
          }
        }
      }
    },
    HandleclickImg(photoUrl, index, isMore){
      if (isMore) {
        ImagePreview({
          images: photoUrl,
          startPosition: index,
        });
      } else {
        let arr = new Array()
        arr.push(photoUrl)
        ImagePreview({
          images: arr,
          startPosition: index,
        });
      }
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getClerkCategoryCheckDetail(
          this.id,
          this.clerkId
      ).then(res => {
        Toast.clear()
        let data = res.data;
        if (data.code == 0) {
          this.examineCheck = data.examineCheck
          this.examineCheckContent = data.examineCheckContent
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
      this.videoElement = document.getElementsByTagName('video')
    },

    //全选
    selectAll(){
      this.$refs.checkAll.toggleAll(true);
    },
    // 播放录音
    playAudio(id, audioUrl) {
      if (this.player.audio != null) {
        this.player.audio.pause()
      }
      if (this.player.id == id) {
        this.player.id = null
        this.player.audio = null
      } else {
        const videoElement = this.videoElement
        for (let i = 0; i < videoElement.length; i++) {
          this.videoElement[i].pause()
        }
        const audio = new Audio(audioUrl)
        audio.play()
        // 播放结束事件
        audio.onended = () => {
          this.player.id = null
          this.player.audio = null
        }
        this.player.id = id
        this.player.audio = audio
      }
    },
    handleConfirm(){

      Toast.loading({
        mask: true,
        message: '提交审核中...'
      })
      checkClerkCategoryExamineApply(this.id, this.checkStatus, this.reason).then(res => {
        Toast.clear()
        let data = res.data;
        if (data.code == 0) {
          Dialog.alert({
            title: '审核成功',
          }).then(() => {
            this.$router.back(-1)
            this.loadData();
          })
        } else {
          Dialog.alert({
            title: '审核失败',
            message: data.msg
          })
        }
      })
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.clerkId = this.$route.query.clerkId
    this.loadData()
  }
}
</script>

<style lang="less">



</style>
<style lang="less" scoped>
.page {
  padding-bottom: 100px;

  .content {
    font-size: 14px;
    padding: 10px 15px;

    .userData{
      display: flex;
      align-items: center;

      .avater{
        border-radius: 50%;
        width: 50px;
        height: 50px;
      }
    }

    .row {
      .user_head {
        position: relative;
        padding: 10px;
        .level {
          position: absolute;
          left: 50%;
          height: 10px;
          font-size: 10px;
          white-space: nowrap;
          bottom: 5px;
          transform: translateX(-50%);
        }

        .avatarFrame {
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }

  .row {
    display: flex;
    color: #333;
    margin: 10px 0;
    align-items: center;
  }

  .label {
    width: 80px;
    color: #888;
  }

  .value {
    flex: 1;
  }

  .bottom-bar {
    padding: 10px 15px;
    /*background: #fff;*/
    /*box-shadow: 0 0 3px 0px #333;*/
    /*position: fixed;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*right: 0;*/
  }

  .commentBox {
    width: 100%;
    background: #fff;
    padding: 15px;
    margin-top: 20px;
    box-sizing: border-box;
  }

  .imgStyle {
    margin-left: 10px;
    flex: 0 0 15%;
    height: 0;
    padding-bottom: 15%;
    overflow: hidden;
    position: relative;
  }

  .screenshot {
    width: 100%;
    display: flex;
    align-content: flex-start;
    flex-flow: row wrap;
  }

  .screenshotImg {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .module {
    margin-top: 15px;
    padding: 0px 15px;
    position: relative;

    /deep/ .van-cell {
      padding: 15px 0;
      background: transparent;
      font-size: 14px;
      line-height: 20px;
      font-family: PingFangSC-Regular, PingFang SC;

      &.module-title {
        padding-bottom: 0;
      }

      .van-cell__title {
        width: 90px;
        flex: none;
        box-sizing: border-box;
        font-weight: 600;
        color: #333333;
      }

      .van-cell__value {
        font-weight: 400;
        color: #999999;
      }

      &.van-cell--required {
        &::before {
          left: 0px;
        }
      }
    }
  }

  .image-uploader {
    /deep/ .van-uploader__wrapper {
      .van-uploader__preview {
        .van-uploader__preview-delete {
          top: 0;
          right: 0;
          color: var(--primary-color);
        }
      }
    }
  }
  .wx {
    height: 20px;
    line-height: 18px;
    background-color: #f87d23;
    border: 1px solid #f87d23;
    margin-right: 15px
  }

}

.audio-player {
  width: 50%;
  height: 25px;
  background: #54D3C3;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 9px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background-size: cover;
  z-index: 3;

  .audio {
    width: 100%;
    padding: 0 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .wave {
      margin-left: 3px;
    }

    .duration {
      font-size: 8px;
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #fff;
    }
  }

  &.playing {
    .wave {
      @keyframes wave {
        from {
          height: 18px;
        }
        to {
          height: 12px;
        }
      }
      animation: wave .5s linear 0s infinite alternate;
    }
  }
}
.play-tubiao{
  width: 14px;
  line-height: 14px;
  font-size: 6px;
  text-align: center;
}
.play-a{
  color: #fff;
  vertical-align: middle;
}
</style>
